<template>
  <div class="qmyx-container"></div>
</template>

<script>
import { getAgent, getLoginNew } from "../api";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      introAgentId: "",
      introAgentName: "",
      id: "",
      psn: ""
    };
  },
  methods: {
    async checkAgent() {
      // await getLogin();
      await getLoginNew();
      try {
        await getAgent();
        this.$router.push({
          name: "t9_my"
        });
      } catch (err) {
        this.$router.push({
          name: "agent-auth",
          params: {
            introAgentId: this.introAgentId,
            introAgentName: this.introAgentName
          }
        });
      }
    }
  },
  mounted() {
    this.introAgentId = this.$route.query.introAgentId;
    this.introAgentName = this.$route.query.introAgentName;
    this.id = this.$route.query.id;
    this.psn = this.$route.query.psn;
    Cookies.set(
      "t9_20200131_init",
      JSON.stringify({ id: this.id, psn: this.psn }),
      {
        expires: new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000)
      }
    );
    this.checkAgent();
    // introAgentId=2c90851f70e18abe0170e18e28a90003&introAgentName=hf264336
  }
};
</script>

<style></style>
